// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IAddFavoriteEntityPublicRequest {
  /** Идентификатор объявления **/
  entityId: number;
  /** Тип объекта **/
  entityType: EEntityType;
  /** Тип сделки **/
  dealType: EDealType;
  /** Добавлять ли в папку, если у пользователя есть недавно редактированная папка **/
  addToFolder?: TAddFavoriteEntityPublicRequest_AddToFolder;
}

export enum EEntityType {
  /** Жилая **/
  'OfferResidental' = 'offerResidental',
  /** Загородка **/
  'OfferSuburban' = 'offerSuburban',
  /** Коммерческая **/
  'OfferCommercial' = 'offerCommercial',
  /** ЖК **/
  'Newbuilding' = 'newbuilding',
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export type TAddFavoriteEntityPublicRequest_AddToFolder = null | boolean;
